/**
 * Platform configuration for social media integrations
 */

export interface PlatformConfig {
  name: string;
  color: string;
  icon?: string;
  supported: boolean;
}

export const PLATFORM_CONFIG: Record<string, PlatformConfig> = {
  instagram: {
    name: 'Instagram',
    color: '#E4405F',
    icon: 'Instagram',
    supported: true
  },
  facebook: {
    name: 'Facebook',
    color: '#1877F2',
    icon: 'Facebook',
    supported: true
  },
  linkedin: {
    name: 'LinkedIn',
    color: '#0A66C2',
    icon: 'Linkedin',
    supported: false // Will be implemented
  },
  youtube: {
    name: 'YouTube',
    color: '#FF6B35',
    icon: 'Youtube',
    supported: true
  },
  twitter: {
    name: 'X',
    color: '#1D9BF0',
    icon: 'X',
    supported: false // Future implementation
  },
  tiktok: {
    name: 'TikTok',
    color: '#FF0050',
    icon: 'Music',
    supported: false // Future implementation
  }
};

export const getPlatformConfig = (platform: string): PlatformConfig => {
  return PLATFORM_CONFIG[platform.toLowerCase()] || {
    name: platform,
    color: '#6B7280',
    supported: false
  };
};

export const getPlatformColor = (platform: string): string => {
  return getPlatformConfig(platform).color;
};

export const getPlatformName = (platform: string): string => {
  return getPlatformConfig(platform).name;
};

export const getSupportedPlatforms = (): string[] => {
  return Object.keys(PLATFORM_CONFIG).filter(
    platform => PLATFORM_CONFIG[platform].supported
  );
};

export const getAllPlatforms = (): string[] => {
  return Object.keys(PLATFORM_CONFIG);
};